import { FunctionComponent, useEffect } from 'react';
import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import { useLayout } from '../../../providers/Layout.provider';
import { useToken } from '../../../providers/Token.provider';
import styles from '../../Messages/Messages.module.scss';

type FC = FunctionComponent;
const { Icon } = vp;
const RequestFailed: FC = () => {
  const { setLayoutInfo } = useLayout();
  const { t } = useTranslation('translations', { keyPrefix: 'RequestFailed' });
  const { token } = useToken();
  useEffect(() => {
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'moon',
      '',
      80,
      20,
      0,
      false,
      true,
    );
  }, []);

  return (
    <div className={styles.welcomeContainer} style={{ maxWidth: '770px' }}>
      <div className={styles.welcomeMSGContainer}>
        <div className={styles.iconContainerError}>
          <Icon icon="error2" color="none" width="72px" height="72px" />
        </div>
        <div className={styles.title}>{t('title')}</div>
        <div className={styles.welcomeDescContainer}>
          <p>{t('message')}</p>
        </div>
      </div>
    </div>
  );
};

export default RequestFailed;
